import { BASE_PATH as h, BaseAPI as g, operationServerMap as C } from "../base.js";
import { DUMMY_BASE_URL as m, assertParamExists as l, createRequestFunction as p, serializeDataIfNeeded as x, setSearchParams as v, toPathString as O } from "../common.js";
import V from "axios";
var I = function(t) {
  return {
    merchantCreditProductCreateCreditProduct: async (c, a = {}) => {
      l("merchantCreditProductCreateCreditProduct", "creditProductDTO", c);
      const o = new URL("/merchant/mms/credit_product", m);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...a
      }, d = {}, n = {};
      d["Content-Type"] = "application/json", v(o, n);
      let i = r && r.headers ? r.headers : {};
      return e.headers = {
        ...d,
        ...i,
        ...a.headers
      }, e.data = x(c, e, t), {
        url: O(o),
        options: e
      };
    },
    merchantCreditProductDeleteCreditProduct: async (c, a = {}) => {
      l("merchantCreditProductDeleteCreditProduct", "creditProductId", c);
      const o = "/merchant/mms/credit_product/{creditProductId}".replace("{creditProductId}", encodeURIComponent(String(c))), r = new URL(o, m);
      let e;
      t && (e = t.baseOptions);
      const d = {
        method: "DELETE",
        ...e,
        ...a
      }, n = {};
      v(r, {});
      let i = e && e.headers ? e.headers : {};
      return d.headers = {
        ...n,
        ...i,
        ...a.headers
      }, {
        url: O(r),
        options: d
      };
    },
    merchantCreditProductDeleteCreditProducts: async (c, a = {}) => {
      l("merchantCreditProductDeleteCreditProducts", "requestBody", c);
      const o = new URL("/merchant/mms/credit_product/batch", m);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "DELETE",
        ...r,
        ...a
      }, d = {}, n = {};
      d["Content-Type"] = "application/json", v(o, n);
      let i = r && r.headers ? r.headers : {};
      return e.headers = {
        ...d,
        ...i,
        ...a.headers
      }, e.data = x(c, e, t), {
        url: O(o),
        options: e
      };
    },
    merchantCreditProductGetCreditProductById: async (c, a = {}) => {
      l("merchantCreditProductGetCreditProductById", "creditProductId", c);
      const o = "/merchant/mms/credit_product/{creditProductId}".replace("{creditProductId}", encodeURIComponent(String(c))), r = new URL(o, m);
      let e;
      t && (e = t.baseOptions);
      const d = {
        method: "GET",
        ...e,
        ...a
      }, n = {};
      v(r, {});
      let i = e && e.headers ? e.headers : {};
      return d.headers = {
        ...n,
        ...i,
        ...a.headers
      }, {
        url: O(r),
        options: d
      };
    },
    merchantCreditProductGetCreditProductExchangePage: async (c, a = {}) => {
      l("merchantCreditProductGetCreditProductExchangePage", "creditProductExchangePageRequestDTO", c);
      const o = new URL("/merchant/mms/credit_product/exchange_page", m);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...a
      }, d = {}, n = {};
      d["Content-Type"] = "application/json", v(o, n);
      let i = r && r.headers ? r.headers : {};
      return e.headers = {
        ...d,
        ...i,
        ...a.headers
      }, e.data = x(c, e, t), {
        url: O(o),
        options: e
      };
    },
    merchantCreditProductGetCreditProductExchangeRecords: async (c, a, o = {}) => {
      l("merchantCreditProductGetCreditProductExchangeRecords", "creditProductId", c), l("merchantCreditProductGetCreditProductExchangeRecords", "exchangeRecordPageRequestDTO", a);
      const r = "/merchant/mms/credit_product/{creditProductId}/exchange_records".replace("{creditProductId}", encodeURIComponent(String(c))), e = new URL(r, m);
      let d;
      t && (d = t.baseOptions);
      const n = {
        method: "POST",
        ...d,
        ...o
      }, i = {}, s = {};
      i["Content-Type"] = "application/json", v(e, s);
      let u = d && d.headers ? d.headers : {};
      return n.headers = {
        ...i,
        ...u,
        ...o.headers
      }, n.data = x(a, n, t), {
        url: O(e),
        options: n
      };
    },
    merchantCreditProductGetCreditProductPage: async (c, a = {}) => {
      l("merchantCreditProductGetCreditProductPage", "creditProductPageRequestDTO", c);
      const o = new URL("/merchant/mms/credit_product/page", m);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...a
      }, d = {}, n = {};
      d["Content-Type"] = "application/json", v(o, n);
      let i = r && r.headers ? r.headers : {};
      return e.headers = {
        ...d,
        ...i,
        ...a.headers
      }, e.data = x(c, e, t), {
        url: O(o),
        options: e
      };
    },
    merchantCreditProductToggleCreditProductStatus: async (c, a, o = {}) => {
      l("merchantCreditProductToggleCreditProductStatus", "creditProductId", c), l("merchantCreditProductToggleCreditProductStatus", "status", a);
      const r = new URL("/merchant/mms/credit_product/toggleStatus", m);
      let e;
      t && (e = t.baseOptions);
      const d = {
        method: "PATCH",
        ...e,
        ...o
      }, n = {}, i = {};
      c !== void 0 && (i.creditProductId = c), a !== void 0 && (i.status = a), v(r, i);
      let s = e && e.headers ? e.headers : {};
      return d.headers = {
        ...n,
        ...s,
        ...o.headers
      }, {
        url: O(r),
        options: d
      };
    },
    merchantCreditProductUpdateCreditProduct: async (c, a = {}) => {
      l("merchantCreditProductUpdateCreditProduct", "creditProductDTO", c);
      const o = new URL("/merchant/mms/credit_product", m);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...a
      }, d = {}, n = {};
      d["Content-Type"] = "application/json", v(o, n);
      let i = r && r.headers ? r.headers : {};
      return e.headers = {
        ...d,
        ...i,
        ...a.headers
      }, e.data = x(c, e, t), {
        url: O(o),
        options: e
      };
    }
  };
}, P = function(t) {
  const c = I(t);
  return {
    async merchantCreditProductCreateCreditProduct(a, o) {
      var r, e;
      const d = await c.merchantCreditProductCreateCreditProduct(a, o), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = C["MerchantCreditProductApi.merchantCreditProductCreateCreditProduct"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (s, u) => p(d, V, h, t)(s, i || u);
    },
    async merchantCreditProductDeleteCreditProduct(a, o) {
      var r, e;
      const d = await c.merchantCreditProductDeleteCreditProduct(a, o), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = C["MerchantCreditProductApi.merchantCreditProductDeleteCreditProduct"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (s, u) => p(d, V, h, t)(s, i || u);
    },
    async merchantCreditProductDeleteCreditProducts(a, o) {
      var r, e;
      const d = await c.merchantCreditProductDeleteCreditProducts(a, o), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = C["MerchantCreditProductApi.merchantCreditProductDeleteCreditProducts"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (s, u) => p(d, V, h, t)(s, i || u);
    },
    async merchantCreditProductGetCreditProductById(a, o) {
      var r, e;
      const d = await c.merchantCreditProductGetCreditProductById(a, o), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = C["MerchantCreditProductApi.merchantCreditProductGetCreditProductById"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (s, u) => p(d, V, h, t)(s, i || u);
    },
    async merchantCreditProductGetCreditProductExchangePage(a, o) {
      var r, e;
      const d = await c.merchantCreditProductGetCreditProductExchangePage(a, o), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = C["MerchantCreditProductApi.merchantCreditProductGetCreditProductExchangePage"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (s, u) => p(d, V, h, t)(s, i || u);
    },
    async merchantCreditProductGetCreditProductExchangeRecords(a, o, r) {
      var e, d;
      const n = await c.merchantCreditProductGetCreditProductExchangeRecords(a, o, r), i = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, s = (d = C["MerchantCreditProductApi.merchantCreditProductGetCreditProductExchangeRecords"]) === null || d === void 0 || (d = d[i]) === null || d === void 0 ? void 0 : d.url;
      return (u, S) => p(n, V, h, t)(u, s || S);
    },
    async merchantCreditProductGetCreditProductPage(a, o) {
      var r, e;
      const d = await c.merchantCreditProductGetCreditProductPage(a, o), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = C["MerchantCreditProductApi.merchantCreditProductGetCreditProductPage"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (s, u) => p(d, V, h, t)(s, i || u);
    },
    async merchantCreditProductToggleCreditProductStatus(a, o, r) {
      var e, d;
      const n = await c.merchantCreditProductToggleCreditProductStatus(a, o, r), i = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, s = (d = C["MerchantCreditProductApi.merchantCreditProductToggleCreditProductStatus"]) === null || d === void 0 || (d = d[i]) === null || d === void 0 ? void 0 : d.url;
      return (u, S) => p(n, V, h, t)(u, s || S);
    },
    async merchantCreditProductUpdateCreditProduct(a, o) {
      var r, e;
      const d = await c.merchantCreditProductUpdateCreditProduct(a, o), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = C["MerchantCreditProductApi.merchantCreditProductUpdateCreditProduct"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (s, u) => p(d, V, h, t)(s, i || u);
    }
  };
}, G = function(t, c, a) {
  const o = P(t);
  return {
    merchantCreditProductCreateCreditProduct(r, e) {
      return o.merchantCreditProductCreateCreditProduct(r.creditProductDTO, e).then((d) => d(a, c));
    },
    merchantCreditProductDeleteCreditProduct(r, e) {
      return o.merchantCreditProductDeleteCreditProduct(r.creditProductId, e).then((d) => d(a, c));
    },
    merchantCreditProductDeleteCreditProducts(r, e) {
      return o.merchantCreditProductDeleteCreditProducts(r.requestBody, e).then((d) => d(a, c));
    },
    merchantCreditProductGetCreditProductById(r, e) {
      return o.merchantCreditProductGetCreditProductById(r.creditProductId, e).then((d) => d(a, c));
    },
    merchantCreditProductGetCreditProductExchangePage(r, e) {
      return o.merchantCreditProductGetCreditProductExchangePage(r.creditProductExchangePageRequestDTO, e).then((d) => d(a, c));
    },
    merchantCreditProductGetCreditProductExchangeRecords(r, e) {
      return o.merchantCreditProductGetCreditProductExchangeRecords(r.creditProductId, r.exchangeRecordPageRequestDTO, e).then((d) => d(a, c));
    },
    merchantCreditProductGetCreditProductPage(r, e) {
      return o.merchantCreditProductGetCreditProductPage(r.creditProductPageRequestDTO, e).then((d) => d(a, c));
    },
    merchantCreditProductToggleCreditProductStatus(r, e) {
      return o.merchantCreditProductToggleCreditProductStatus(r.creditProductId, r.status, e).then((d) => d(a, c));
    },
    merchantCreditProductUpdateCreditProduct(r, e) {
      return o.merchantCreditProductUpdateCreditProduct(r.creditProductDTO, e).then((d) => d(a, c));
    }
  };
}, T = class extends g {
  merchantCreditProductCreateCreditProduct(t, c) {
    return P(this.configuration).merchantCreditProductCreateCreditProduct(t.creditProductDTO, c).then((a) => a(this.axios, this.basePath));
  }
  merchantCreditProductDeleteCreditProduct(t, c) {
    return P(this.configuration).merchantCreditProductDeleteCreditProduct(t.creditProductId, c).then((a) => a(this.axios, this.basePath));
  }
  merchantCreditProductDeleteCreditProducts(t, c) {
    return P(this.configuration).merchantCreditProductDeleteCreditProducts(t.requestBody, c).then((a) => a(this.axios, this.basePath));
  }
  merchantCreditProductGetCreditProductById(t, c) {
    return P(this.configuration).merchantCreditProductGetCreditProductById(t.creditProductId, c).then((a) => a(this.axios, this.basePath));
  }
  merchantCreditProductGetCreditProductExchangePage(t, c) {
    return P(this.configuration).merchantCreditProductGetCreditProductExchangePage(t.creditProductExchangePageRequestDTO, c).then((a) => a(this.axios, this.basePath));
  }
  merchantCreditProductGetCreditProductExchangeRecords(t, c) {
    return P(this.configuration).merchantCreditProductGetCreditProductExchangeRecords(t.creditProductId, t.exchangeRecordPageRequestDTO, c).then((a) => a(this.axios, this.basePath));
  }
  merchantCreditProductGetCreditProductPage(t, c) {
    return P(this.configuration).merchantCreditProductGetCreditProductPage(t.creditProductPageRequestDTO, c).then((a) => a(this.axios, this.basePath));
  }
  merchantCreditProductToggleCreditProductStatus(t, c) {
    return P(this.configuration).merchantCreditProductToggleCreditProductStatus(t.creditProductId, t.status, c).then((a) => a(this.axios, this.basePath));
  }
  merchantCreditProductUpdateCreditProduct(t, c) {
    return P(this.configuration).merchantCreditProductUpdateCreditProduct(t.creditProductDTO, c).then((a) => a(this.axios, this.basePath));
  }
};
export {
  T as MerchantCreditProductApi,
  I as MerchantCreditProductApiAxiosParamCreator,
  G as MerchantCreditProductApiFactory,
  P as MerchantCreditProductApiFp
};

//# sourceMappingURL=merchant-credit-product-api.js.map